import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  & .hefesto-textfield__label-wrapper {
    display: none;
  }

  & .hefesto-textfield__input-wrapper {
    & > input {
      padding-right: 0;
    }
  }

  &.input-error {
    & > input,
    & > button {
      border: 1px solid ${({ theme }) => theme.colors.red};
    }
  }
`;
